export default class JobReference {
  constructor(json) {
    this.id = json.id
    this.referenceType = json.reference_type
    this.referencedId = json.referenced_id
    this.url = json.url
  }

  id: number
  referencedId: string
  url: string
  referenceType: string
}
